<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg1" ref="statisTitle">
            <span>学科资源分析</span>
        </div>
        <div class="content" :style="contentStyleObj">
            <div class="left-content">
                <div class="num" :title=teaCoursewareCount>{{ formattedTeaCoursewareCount }}</div>
                <div class="text">上传总量</div>
            </div>
            <div class="right-content">
                <div class="right-title" ref="rightTitle">
                    <span style="font-size: 12px;">学科上传排行榜</span>
                </div>
                <div class="table-content">
                    <div v-for="(subject, index) in teaCourseware" :key="subject.subjectId" class="table-item">
                        <div class="rank">{{ `NO.${index + 1}&#32${subject.name}` }}</div>
                        <div>{{ subject.count }}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "coursewareStatis",
    data() {
        return {
            boxWrapStyleObj: {
                height: ''
            },
            contentStyleObj: {
                height: ''
            },
            rowStyleObj: {
                height: '',
                lineHeight: ''
            }
        }
    },
    props: {
        teaCourseware: {
            type: Array,
            default: function () {
                return []
            }
        },
        screenHeight: Number,
        titleHeight: Number,
        teaCoursewareCount: [String, Number]
    },
    computed: {
        totalCourseWare() {
            let total = 0;
            this.teaCourseware.filter((item) => {
                total += item.count
            });
            return total;
        },
        formattedTeaCoursewareCount() {
            return this.teaCoursewareCount > 10000 ? Math.floor(this.teaCoursewareCount / 10000) + 'w' : this.teaCoursewareCount;
        }
    },
    watch: {
        'screenHeight': 'initBoxHeight',
        'titleHeight': 'initBoxHeight'
    },
    methods: {
        /**
         * 初始化box高度
         */
        initBoxHeight() {
            let winHeight = window.innerHeight;
            if (winHeight < 900) {
                winHeight = 938;
            }
            let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
            let contentHeight = boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
            this.boxWrapStyleObj.height = boxWrapHeight + 'px';
            this.contentStyleObj.height = contentHeight + 'px';

            let rowHight = (contentHeight - this.$refs.rightTitle.offsetHeight) / 6;
            this.rowStyleObj.height = rowHight + 'px';
            this.rowStyleObj.lineHeight = rowHight + 'px';
        }
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";

.bg1 {
    background-image: url("../../../assets/images/sydataboard/title-bg.png");
}

.content {
    width: 100%;
    height: calc(100% - 66px);
    margin-top: 0px !important;
    display: flex;
    // align-items: center;
    // justify-content: center;
    justify-content: space-between;

    .left-content {

        height: 140px;
        width: 110px;
        background-image: url("~@/assets/images/shangchuanbg.png");
        background-size: 100% 100%; // 修改这里
        // background-repeat: no-repeat;
        // background-position: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 9% 5% 0 0;

        .num {
            font-size: vh(38);
            font-family: Consolas, 'Courier New', monospace;
            font-weight: bold;

            color: #FFFFFF;
        }

        .text {
            font-size: vh(18);
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #6EA0D3;
        }
    }

    .right-content {
        width: 68%;

        .right-title {
            margin: 0 auto;
            text-align: left;
            padding: vh(7) 0px 0px;

            @media only screen and (max-width: 1400px) {
                padding: vh(5) 0px;
            }

            span {
                color: #0efcff;
                font-size: vw(16);
            }
        }

        .table-content {
            width: 100%;
            height: calc(100% - 25px);
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .table-item {
                font-size: vw(14);
                font-family: Microsoft YaHei;
                color: #6EA0D3;
                line-height: vw(35);
                text-align: left;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .rank {
                    font-size: vw(14);
                    // font-family: DingTalk JinBuTi;
                    // width: 150px;
                    font-weight: 500;
                    color: #6EA0D3;
                    display: inline-flex;
                    align-items: center;
                    line-height: vw(18);
                    padding:vw(5) vw(10);
                    text-align: left;
                    background-size: 100% 100%;
                    background: url('../../../assets/images/sydataboard/four.png') no-repeat;
                    // margin-right: 10vh;
                }

            }
        }
    }
}</style>
